<template>
    <div>
      <title-list></title-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
  